<template>
  <div class="container-page">
    <p class="title-inner">Маппинг стран</p>
    <div class="mb-16">
      <ButtonComponent
        v-permission="permissions.import"
        :disabled="importInProgress"
        @click="importExcel()"
        mod="gradient-bg"
      >
        {{ !importInProgress ? 'Добавить значение' : 'Загрузка...' }}
      </ButtonComponent>
    </div>
    <DefaultFilter class="mb-16" :filterValue="filter" @loadFilter="onLoadFilter" />
    <div v-if="isAccessAllowed">
      <div class="table-container mb-16 js-table-arrow">
        <table class="stockTable">
          <thead>
            <tr>
              <th>Наименование страны в справочнике</th>
              <th>Наименование страны в источнике</th>
              <th class="filter"></th>
            </tr>
            <tr>
              <th class="filter">
                <FilterInput
                  type="select2"
                  :select2Options="countries"
                  :select2Settings="select2Settings"
                  v-model="filter.filterCountryID"
                  @update:modelValue="setCountryReferenceName()"
                  placeholder="(Все)"
                  @valueChangedDebounced="changeFilter"
                />
              </th>
              <th class="filter"></th>
              <th class="filter"></th>
            </tr>
          </thead>
          <tbody v-if="page.items?.length && !isLoading">
            <tr v-for="item in page.items" :key="item.id">
              <td>{{ item.countryReferenceName }}</td>
              <td>{{ item.countrySourceName }}</td>
            </tr>
          </tbody>
          <tbody v-else-if="isLoading">
            <tr>
              <td class="text-center" colspan="3">Загрузка...</td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td class="text-center" colspan="3">Нет данных.</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-if="page.pagesTotal > 1">
        <Pagination
          :pageCount="page.pagesTotal"
          :currentPage="page.pageNumber"
          @change="onPageChange($event, false)"
          @more="onPageChange($event, true)"
        />
      </div>
    </div>
    <ModalComponent v-model="importModal" title="Добавить значение" @close="closeModal">
      <div>
        <div class="form-group filter">
          <label class="control-label">Выберите страну</label>
          <FilterInput
            type="select2"
            :select2Options="countries"
            :select2Settings="select2Settings"
            v-model="selectedCountry"
            placeholder="Не указано"
          />
        </div>

        <div class="form-group">
          <label class="control-label">Альтернативное название</label>
          <input type="text" id="text-input" placeholder="Страна Китай" class="form-control" v-model="countryName" />
        </div>

        <div class="mb-16">
          <ButtonComponent class="mr-8" mod="gradient-bg" @click="doImport()">Загрузить</ButtonComponent>
          <ButtonComponent mod="border" @click="closeModal()">Закрыть</ButtonComponent>
        </div>
      </div>
    </ModalComponent>
  </div>
</template>

<script>
  import DefaultFilter from '@/common/components/DefaultFilter.vue';
  import FilterInput from '@/common/components/FilterInput.vue';
  import ButtonComponent from '@/common/components/redesigned/ButtonComponent.vue';
  import Constants from '@/common/constants';
  import security from '@/common/mixins/security';
  import Utils from '@/common/utils';
  import { loadFilter, saveFilter } from '@/common/utils/filterManager';

  import ModalComponent from '@/components/modals/ModalComponent.vue';

  import Api from '../api/index';

  const PERMISSIONS = {
    view: Constants.Permissions.CountryMappingView,
    import: Constants.Permissions.CountryMappingCreate,
  };

  export default {
    name: 'CountryMapping',
    components: { FilterInput, ModalComponent, ButtonComponent, DefaultFilter },
    mixins: [security],
    data() {
      return {
        page: {},
        request: {
          pageNumber: 1,
          pageSize: Constants.pageSize,
          IsExport: true,
        },
        filter: {
          CountryReferenceName: null,
          filterCountryID: null,
        },
        importInProgress: false,
        importModal: false,
        isLoading: false,
        select2Settings: Constants.select2Settings,
        countries: [],
        countryName: '',
        selectedCountry: '',
      };
    },
    computed: {
      permissions: () => PERMISSIONS,
    },
    created() {
      this.checkPermissionAndRedirect(PERMISSIONS.view).then((isAllowed) => {
        if (!isAllowed) return;

        loadFilter(this.$options.name).then((response) => {
          let filter = response;
          if (filter) {
            this.filter = filter;
          }
          this.loadDictionaries();
          this.loadPage();
        });
      });
    },
    methods: {
      loadPage(append) {
        this.isLoading = !append;
        const request = Object.assign(this.filter, this.request);
        Api.search('countrymapping', request)
          .then((response) => {
            if (!append) {
              this.page = {};
              this.$nextTick(() => {
                this.page = response.data;
              });
            } else if (response.data) {
              this.page.pageNumber = response.data.pageNumber;
              this.page.items = this.page.items.concat(response.data.items);
            }
            this.isLoading = false;
          })
          .catch(() => {
            this.isLoading = false;
          });
      },
      loadDictionaries() {
        Utils.searchNsi('countrylist', {})
          .then((response) => {
            this.countries = response.data;
          })
          .catch((error) => {
            console.error(error?.response?.data);
          });
      },
      importExcel() {
        this.importModal = true;
      },
      doImport() {
        if (this.countryName && this.selectedCountry) {
          this.importInProgress = true;

          Api.mappingCreate(true, this.selectedCountry, this.countryName)
            .then(() => {
              Constants.alert.fire('Импорт', 'Импорт успешно выполнен.', 'success');
              this.loadPage();
              this.importInProgress = false;
            })
            .catch((error) => {
              Constants.alert.fire(
                'Импорт',
                error?.response?.data ? error?.response?.data : 'Ошибка при импорте данных.',
                'error',
              );
              this.importInProgress = false;
            });
        } else {
          Constants.alert.fire('Импорт', 'Не все поля заполнены', 'error');
        }

        this.closeModal();
      },
      getCountryName(id) {
        if (id && this.countries.length) {
          return this.countries.find((item) => item.id == id).text;
        }
      },

      setCountryReferenceName() {
        this.filter.CountryReferenceName = this.getCountryName(this.filter.filterCountryID);
      },
      onPageChange(pageNumber, addToExist) {
        this.request.pageNumber = pageNumber;
        this.loadPage(addToExist);
      },
      changeFilter() {
        this.request.pageNumber = 1;
        saveFilter(this.$options.name, this.filter);
        this.loadPage(false);
      },
      closeModal() {
        this.importModal = false;
        this.selectedCountry = '';
        this.countryName = '';
      },
      onLoadFilter(item) {
        this.filter = item;
        this.changeFilter();
      },
    },
  };
</script>
